module.exports = __webpack_public_path__ + "assets/img/25percent.594406b1.png";